import type { TRouteId } from '$src/generated/routeIds';
import { intercept } from '$src/lib/services/navigation/interceptor';
import { error } from '@sveltejs/kit';
import { match } from 'path-to-regexp';

export const load = async (event) => {
    const { data } = event;
    const { result, navigationSlugs } = data;

    const loadResult = Promise.resolve(result)
        // Sorin:
        // catching should be handled by SSR error handler
        // for client-side errors, we should be covered
        .catch(() => {});

    const [maybePlayRoute] = intercept('PLAY', {});
    const [maybePractiseRoute] = intercept('PRACTICE', {});

    const playRoute: string | undefined = navigationSlugs?.[maybePlayRoute as TRouteId];
    const practiseRoute: string | undefined = navigationSlugs?.[maybePractiseRoute as TRouteId];

    if (!playRoute && !practiseRoute) {
        error(404, { message: 'Page not found', errorId: 'PAGE_NOT_FOUND' });
    }

    const playMatcher = match(playRoute, { decode: decodeURIComponent });
    const practiseMatcher = match(practiseRoute, { decode: decodeURIComponent });

    if (!playMatcher(event.url.pathname) && !practiseMatcher(event.url.pathname)) {
        error(404, { message: 'Page not found', errorId: 'PAGE_NOT_FOUND' });
    }

    return loadResult;
};
